import { Heading, Modal } from '@audio-network/componentlibrary'
import React, { FormEvent, useCallback, useEffect, useRef } from 'react'

import { Button } from '@audio-network/componentlibrary'
import { EditNotesProps } from './EditNotes.types'
import styles from './EditNotes.module.css'
import { useTranslation } from 'next-i18next'

const EditNotes = ({
	isOpen,
	onChangeNotes,
	onClose,
	notes,
	track,
}: EditNotesProps): JSX.Element => {
	const textAreaRef = useRef(null)
	const { t } = useTranslation(['trackrow'])

	useEffect(() => {
		if (notes && isOpen) {
			textAreaRef.current.value = notes
		}
	}, [notes, isOpen])

	const handleNotesSubmit = useCallback(
		(event: FormEvent): void => {
			event.preventDefault()
			onChangeNotes(textAreaRef.current.value, track)
			onClose()
		},
		[onChangeNotes, onClose, track]
	)

	return (
		<Modal
			aria-labelledby={`notes-modal-heading-${track.id}`}
			closeButtonLabel={t('track-notes.close')}
			data-testid="edit-notes-modal"
			isOpen={isOpen}
			onClose={onClose}
		>
			<form onSubmit={handleNotesSubmit}>
				<Heading
					id={`notes-modal-heading-${track.id}`}
					level={2}
					size="M"
					uppercase
				>
					{t('track-notes.notes')}
				</Heading>
				<textarea
					aria-label={t('track-notes.notes')}
					className={styles.textarea}
					name={t('track-notes.notes')}
					rows={4}
					ref={textAreaRef}
				/>
				<Button type="submit">{t('track-notes.update')}</Button>
			</form>
		</Modal>
	)
}

export default EditNotes
